export const TableData = {
  data: [
    {
      createdAt: new Date('2024-10-01T09:15:00Z'),
      transactionType: 'Deposit',
      transferredToken: 5000,
      name: 'Alice Johnson',
      department: 'HR',
      fiat: 'USD',
      status: 'Settled',
    },
    {
      createdAt: new Date('2024-10-02T11:30:45Z'),
      transactionType: 'Withdrawal',
      transferredToken: 2000,
      name: 'Bob Lee',
      department: 'Finance',
      fiat: 'EUR',
      status: 'Pending',
    },
    {
      createdAt: new Date('2024-10-03T13:45:30Z'),
      transactionType: 'Transfer',
      transferredToken: 1500,
      name: 'Charlie Brown',
      department: 'IT',
      fiat: 'GBP',
      status: 'Settled',
    },
    {
      createdAt: new Date('2024-10-04T14:10:20Z'),
      transactionType: 'Deposit',
      transferredToken: 3200,
      name: 'David Smith',
      department: 'Sales',
      fiat: 'USD',
      status: 'Settled',
    },
    {
      createdAt: new Date('2024-10-05T16:05:55Z'),
      transactionType: 'Withdrawal',
      transferredToken: 1000,
      name: 'Emma Williams',
      department: 'HR',
      fiat: 'JPY',
      status: 'Pending',
    },
    {
      createdAt: new Date('2024-10-06T10:00:00Z'),
      transactionType: 'Transfer',
      transferredToken: 2000,
      name: 'Frank Miller',
      department: 'Finance',
      fiat: 'USD',
      status: 'Pending',
    },
    {
      createdAt: new Date('2024-10-07T09:50:15Z'),
      transactionType: 'Deposit',
      transferredToken: 1200,
      name: 'Grace Clark',
      department: 'Marketing',
      fiat: 'EUR',
      status: 'Settled',
    },
    {
      createdAt: new Date('2024-10-08T15:20:40Z'),
      transactionType: 'Withdrawal',
      transferredToken: 3000,
      name: 'Hank Green',
      department: 'IT',
      fiat: 'GBP',
      status: 'Settled',
    },
    {
      createdAt: new Date('2024-10-09T12:30:00Z'),
      transactionType: 'Transfer',
      transferredToken: 4500,
      name: 'Ivy Allen',
      department: 'Operations',
      fiat: 'AUD',
      status: 'Pending',
    },
    {
      createdAt: new Date('2024-10-10T17:00:00Z'),
      transactionType: 'Deposit',
      transferredToken: 8500,
      name: 'Jack Carter',
      department: 'Legal',
      fiat: 'USD',
      status: 'Settled',
    },
    {
      createdAt: new Date('2024-10-11T08:30:25Z'),
      transactionType: 'Withdrawal',
      transferredToken: 7000,
      name: 'Kara Turner',
      department: 'Marketing',
      fiat: 'CAD',
      status: 'Pending',
    },
    {
      createdAt: new Date('2024-10-12T14:15:10Z'),
      transactionType: 'Transfer',
      transferredToken: 1800,
      name: 'Leo Parker',
      department: 'Sales',
      fiat: 'GBP',
      status: 'Settled',
    },
    {
      createdAt: new Date('2024-10-13T09:45:55Z'),
      transactionType: 'Deposit',
      transferredToken: 9200,
      name: 'Mona Reese',
      department: 'HR',
      fiat: 'EUR',
      status: 'Pending',
    },
    {
      createdAt: new Date('2024-10-14T11:30:35Z'),
      transactionType: 'Withdrawal',
      transferredToken: 1600,
      name: 'Nathan Drake',
      department: 'Operations',
      fiat: 'USD',
      status: 'Settled',
    },
  ],
  hasMore: true,
};
